// extracted by mini-css-extract-plugin
module.exports = {"wrp":"ElementsBlock_wrp__1KCIK"};